import { Expose, Transform, Type } from 'class-transformer';
import { temporalZonedTransformer } from 'src/lib/utilities/api/class-transformer-types';
import { ClassroomSessionStatusType } from './classroom-search.model';

export class ClassroomSessionCourseModel {
	course_id: number;
	course_name: string;
	term: number;
	term_type: number;
	term_type_code: string;
}

export function ClassroomSessionCourseModel_ClassTransform_Type() {
	return ClassroomSessionCourseModel;
}

export class ClassroomSessionProgramModel {
	program_id: number;
	program_name: string;
}

export function ClassroomSessionProgramModel_ClassTransform_Type() {
	return ClassroomSessionProgramModel;
}

export class ClassroomSessionModel {
	id: number;
	name: string;
	@Expose({ name: 'registration_start_timestamp' })
	@Transform(temporalZonedTransformer)
	registration_start: Temporal.ZonedDateTime;
	@Expose({ name: 'registration_end_timestamp' })
	@Transform(temporalZonedTransformer)
	registration_end: Temporal.ZonedDateTime;
	status: ClassroomSessionStatusType;
	@Type(ClassroomSessionCourseModel_ClassTransform_Type)
	courses: ClassroomSessionCourseModel[];
	@Type(ClassroomSessionProgramModel_ClassTransform_Type)
	programs?: ClassroomSessionProgramModel[];
}

export function ClassroomSessionModel_ClassTransform_Type() {
	return ClassroomSessionModel;
}

export class ClassroomSessionListModel {
	@Type(ClassroomSessionModel_ClassTransform_Type)
	results: ClassroomSessionModel[];
	count: number;
}

export interface ClassroomSessionCourseArgument {
	course_id: number;
	term_type: number;
	term: number;
}

export interface ClassroomSessionArgument {
	name: string;
	registration_start_timestamp?: number;
	registration_end_timestamp?: number;
	courses?: ClassroomSessionCourseArgument[];
	programs?: number[];
}
